import {CSSProperties, FC} from 'react';


export interface IIconFoursquareProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconFoursquare: FC<IIconFoursquareProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 0c6.624 0 12 5.376 12 12s-5.376 12-12 12S0 18.624 0 12 5.376 0 12 0Zm4.535 4H7.627C6.404 4 6 4.94 6 5.53v14.406c0 .674.395.92.594 1 .202.082.743.152 1.073-.237l4.274-5.044c.081-.09.103-.102.166-.103h2.775c1.144 0 1.323-.836 1.445-1.318l1.584-8.07C18.189 4.758 17.84 4 16.535 4Zm-.97 1.87c.268 0 .51.256.441.58h-.002l-.371 1.982c-.039.216-.31.439-.55.439h-3.471c-.392 0-.672.275-.672.674v.431c0 .4.28.685.672.685h2.947c.27 0 .542.305.483.604-.059.295-.342 1.786-.371 1.952-.03.163-.222.448-.551.448h-2.397c-.44 0-.56.06-.864.42 0 0-.29.377-2.918 3.596-.029.03-.058.02-.058-.01V6.421c0-.256.222-.551.542-.551h7.14Z" clipRule="evenodd" />
        </svg>
    );
};
